import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  RegionDetails,
  RegionsFilter,
} from '../../features/regions/regionsSlice';

export function fetchRegions(regionsFilter: RegionsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: regionsFilter,
  };

  return axios
    .get('/location/regions/getregions', config)
    .then(res => res.data);
}

export function fetchRegionDetails(regionId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { regionId },
  };

  return axios
    .get('/location/regions/getregiondetails', config)
    .then(res => res.data);
}

export function addRegion(regionData: RegionDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/location/regions/addregion', regionData, config)
    .then(res => res.data);
}

export function updateRegion(regionData: RegionDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/location/regions/updateregion', regionData, config)
    .then(res => res.data);
}

export function deleteRegion(regionId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { regionId },
  };

  return axios
    .delete('/location/regions/deleteregion', config)
    .then(res => res.data);
}
